<template>
  <div
    class="bg-cover bg-top text-center bg-background-primary min-h-full"
    :style="landingPages ? { backgroundImage: `linear-gradient(to right, rgb(87 0 163 / 80%), rgb(0 65 218 / 80%)), url(${backgroundUrl}?blur=30)`}
      : { backgroundImage: `url(${backgroundUrl})` }"
  >
    <div
      class="min-w-full min-h-full flex flex-wrap content-center justify-start"
      :class="
        overlay ? 'card-overlay' : virtualConference ? 'content-start pt-5 md:pt-10' : ''
      "
    >
      <t-container
        class="text-white px-4 flex flex-col w-full justify-start"
        :class="core ? 'core100' : experiment ? 'experiment' : landingPages ? 'landing-pages' : 'hero'"
      >
        <h1
          v-if="hasTitle"
          class="text-white text-left md:text-6xl text-3xl font-bold"
        >
          <slot name="title" />
        </h1>
        <div class="text-white text-base md:text-left text-center md:text-xl">
          <slot name="text" />
        </div>
        <slot />
      </t-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    homepage: Boolean,
    backgroundUrl: {
      type: String,
      default: '',
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    core: {
      type: Boolean,
      default: false,
    },
    virtualConference: {
      type: Boolean,
      default: false,
    },
    experiment: {
      type: Boolean,
      default: false,
    },
    landingPages: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedProfession1: 'PT/PTA',
      selectedState2: 'Tennessee',
    };
  },
  computed: {
    hasTitle() {
      return !!this.$slots.title;
    },
    hasText() {
      return !!this.$slots.text;
    },
  },
};
</script>

<style scoped>
@media (width <= 920px) {
  .hero {
    height: auto;
    padding: 10px 0;
  }

  .experiment {
    height: auto;
    padding: 55px 15px;
  }

  .landing-pages {
    height: auto;
    padding: 35px 0;
  }

  .core100 {
    height: auto;
    padding: 30px 0;
  }

  .card-overlay {
    background: rgb(0 0 0 / 50%);
  }
}

@media (width >= 920px) {
  .hero {
    height: auto;
    padding: 118px 0;
  }

  .experiment {
    height: auto;
    padding: 55px 0;
  }

  .landing-pages {
    height: auto;
    padding: 61px 0;
  }

  .core100 {
    height: auto;
    padding: 116px 0;
  }

  .card-overlay {
    background: rgb(0 0 0 / 50%);
  }
}
</style>
